module.exports = __webpack_public_path__ + "773968e26a831af357a75759478f7b0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/train/view/home/images/2.png
// module id = 178
// module chunks = 1